import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../guards/auth.guard';
import { PunchCardsComponent } from './punch-cards.component';
import { NewPunchCardComponent } from './new-punch-card.component';
import { EditPunchCardComponent } from './edit-punch-card.component';


const routes: Routes = [
  { path: '', component: PunchCardsComponent, canActivate: [AuthGuard] },
  { path: 'new', component: NewPunchCardComponent, canActivate: [AuthGuard] },
  { path: 'new/:jobId/:jobEventId', component: NewPunchCardComponent, canActivate: [AuthGuard] },
  { path: ':id/edit', component: EditPunchCardComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PunchCardsRoutingModule { }
